import pluralize from "pluralize"

import convertToSnakeCase from "@utils/convertToSnakeCase"

export interface GetObjectCardsViewConfigStorageKeyArgs {
    objectType: ObjectType
    objectTypeVariation?: string
    phase: ObjectPhase
    tab: string
}

export default function getObjectCardsViewConfigStorageKey(args: GetObjectCardsViewConfigStorageKeyArgs) {
    const { objectType, phase, tab, objectTypeVariation } = args

    const objectTypePlural = pluralize(objectType)
    const snakeCaseTab = convertToSnakeCase(tab)

    return `${objectTypePlural}${
        objectTypeVariation ? "_" + convertToSnakeCase(objectTypeVariation) : ""
    }_cards__${phase}_${snakeCaseTab}`
}
